import * as React from 'react'
import PropTypes from 'prop-types'
import { useFormitContext } from '@oakwood/formit'
import Button from 'components/Button'
import LoadingButton from 'components/LoadingButton'

const FormitButton = React.forwardRef(function FormitButton(props, ref) {
  const { type, ...other } = props
  const { isSubmitting } = useFormitContext()

  let Component = Button
  const componentsProps = { type, ...other }

  if (type === 'submit') {
    Component = LoadingButton
    componentsProps.pending = isSubmitting
  } else {
    componentsProps.disabled = isSubmitting
  }

  return <Component ref={ref} {...componentsProps} />
})

FormitButton.propTypes = {
  type: PropTypes.string,
}

export default FormitButton
